import { Box, ContentBlock } from 'braid-design-system';
import type React from 'react';

import { DraftJobsContent } from 'src/App/components/DraftJobsContent/DraftJobsContent';
import { JobsContent } from 'src/App/components/JobsContent/JobsContent';
import { useQueryParam } from 'src/hooks/useQueryParam';

const JobsList = () => {
  const { tab } = useQueryParam();

  return (
    <Box paddingX="small">
      <ContentBlock width="large">
        {tab === 'draft' ? <DraftJobsContent /> : <JobsContent />}
      </ContentBlock>
    </Box>
  );
};

export default JobsList;
